<template>
  <div class="all">
    <div class="bommot">
      <ctar1></ctar1>
      <div style="width: 100%; height: 100%; float: left">
        <div style="width: 100%; height: 100%">
          <div style="
              position: absolute;
              z-index: 100;
              width: 15%;
              display: flex;
              left: 4%;
              top: 3%;
            ">
            <div style="width: 90%">
              <el-input v-model="input" placeholder="请输入车辆VIN" id="tipinput"></el-input>
            </div>
            <div style="float: left" @click="lookup()">
              <el-button type="primary">
                <div class="el-icon-search"></div>
              </el-button>
            </div>
          </div>

          <div id="container2" v-loading="loading" element-loading-text="正在加载" :element-loading-spinner="svg"
            element-loading-svg-view-box="-10, -10, 50, 50" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
        </div>
        <div style="
            width: 80%;
            height: 305px;
            position: absolute;
            bottom: 0%;
            left: 3.5%;
            z-index: 999;
          ">
          <div class="bommot1">
            <div style="
                width: 20%;
                display: flex;
                justify-content: space-around;
                align-items: center;
              ">
              <div v-if="online_status == 1">
                <span>车辆状态：</span>
                <button style="
                    width: 13px;
                    height: 13px;
                    border-radius: 50%;
                    background-color: #1efd0c;
                    margin-right: 3px;
                    border: none;
                  "></button>
                <span>在线</span>
              </div>

              <div v-else>
                <span>车辆状态：</span>
                <button style="
                    width: 13px;
                    height: 13px;
                    border-radius: 50%;
                    background-color: rgb(68, 64, 64);
                    margin-right: 3px;
                    border: none;
                  "></button>

                <span>离线</span>
              </div>

              <div v-if="gps_status == 1">
                <span>GPS状态：</span>
                <button style="
                    width: 13px;
                    height: 13px;
                    border-radius: 50%;
                    background-color: #1efd0c;
                    margin-right: 3px;
                    border: none;
                  "></button>
                <span>在线</span>
              </div>
              <div v-else>
                <span>GPS状态：</span>
                <button style="
                    width: 13px;
                    height: 13px;
                    border-radius: 50%;
                    background-color: rgb(68, 64, 64);
                    margin-right: 3px;
                    border: none;
                  "></button>

                <span>离线</span>
              </div>
            </div>
            <div
              style="width: 40% ;display: flex;align-items: center;     align-items: center;  justify-content: center;">
              <div class="slider-demo-block" style="width: 500px;">
                <el-slider v-model="sjvalue" :max='86400' :min='0' :format-tooltip="formatTooltip"
                  @change="updatetime(0)" />
              </div>
            </div>
            <div style="
                width: 25%;
                display: flex;
                align-items: center;
              ">
              <div class="block">
                <el-date-picker v-model="value1" type="date" placeholder="请选择日期" size="small" format="YYYY-MM-DD"
                  :disabled="!plays" value-format="YYYY-MM-DD" />
              </div>
              <div style="width: 230px; margin-left: 10px; margin-right: 10px;">回放速度</div>
              <div>
                <el-select class="topselect w130 ml15" style="width:100%" v-model="value2" filterable remote>
                  <el-option v-for="item in jiange" :key="item.value" :label="item.label" :value="item.value"
                    :disabled="!plays" />
                </el-select>
                <!-- <input class="input" type="text" id="input" value="1" /> -->
              </div>

            </div>

            <div @click="playa(0)" v-if="plays">
              <img src="../../assets/img/paly.png" alt style="width: 30px;height: 30px;" />
            </div>
            <div @click="playa(1)" v-else>
              <img src="../../assets/img/pause.png" alt style="width: 30px;height: 30px;" />
            </div>
          </div>

          <div style="height: 86%;width: 100%;display: flex; background-color: #ffffff;">

            <div style=" height: 100%; width: 23%;">
              <el-table :data="groupA" stripe :show-header="false">
                <el-table-column prop="label" width="100px"></el-table-column>
                <el-table-column prop="value"></el-table-column>
              </el-table>
            </div>

            <div style=" height: 100%; width: 21%;">
              <el-table :data="groupB" :show-header="false" stripe>
                <el-table-column prop="label"></el-table-column>
                <el-table-column prop="value"></el-table-column>
              </el-table>
            </div>
            <div style=" height: 100%; width: 16%;">
              <el-table :data="groupC" :show-header="false" stripe>
                <el-table-column prop="label"></el-table-column>
                <el-table-column prop="value"></el-table-column>
              </el-table>
            </div>
            <div class="table5">
              <el-table :data="groupD" :show-header="false" stripe>
                <el-table-column prop="label"></el-table-column>
                <el-table-column prop="value"></el-table-column>
              </el-table>
            </div>
            <div class="table5">
              <el-table :data="groupE" :show-header="false" stripe>
                <el-table-column prop="label"></el-table-column>
                <el-table-column prop="value"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="right">
    <!-- <div class="right1"> -->
    <el-row>
      <el-col :span="18">
        <el-input v-model="filterText" placeholder="请输入组织名称" />
      </el-col>
      <el-col :span="4">
        <el-button type="primary">搜索</el-button>
      </el-col>
    </el-row>
    <div style="height: 83%">
      <el-scrollbar height="95%">
        <el-tree ref="treeRef" class="filter-tree" :data="tree_data" :props="defaultProps" node-key="value"
          :default-expanded-keys="launch" :filter-node-method="filterNode" @node-click="handleBucketClick" />
        <!-- </div> -->
        <div class="right2">
          <div style="
              width: 100%;
              height: 30px;
              background-color: #0063ae;
              display: flex;
                justify-content: flex-end;
              align-items: center;
            ">
            <RefreshRight color="blue" style="width: 2em; height: 2em; margin-right: 8px" @click="g_area_car_list()" />
          </div>
          <el-row v-for="(item, index) in car_list" :key="index" :class="{ clickback: backid === index }">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <img :src="item.image" />
              </div>
            </el-col>
            <el-col :span="10" style="display: flex;align-items: center;">
              <div @click="togg(item.vin, index)">{{ item.vin }}</div>
            </el-col>
            <el-col :span="6" style="display: flex;align-items: center;justify-content: center;">
              <div @click="f_car(item)" class="grid-content bg-purple">
                <div v-if="item.is_focus == '1'">
                  <img src="../../assets/img/icon_gz.png" />
                </div>

                <div v-else>
                  <img src="../../assets/img/icon_qxgz.png" />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-scrollbar>

      <div class="demo-pagination-block" style="margin-bottom: 20%">
        <el-pagination v-model:currentPage="currentPage3" :page-size="table_page.limit" layout="prev, pager, next"
          :total="table_page.sum" @current-change="handsize"></el-pagination>
      </div>
      <div class="bommot2">
        <div :class="backcolor[index]" v-for="(item, index) in listdata" :key="index">
          <div class="center">{{ item.num }}</div>
          <div class="center">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>


</template>   
<script>
import ctar1 from "../../components/ctar1.vue";
import { ElMessage, ElMessageBox } from 'element-plus'
import {
  get_area_list,
  get_area_car_list,
  focus_car,
  get_all_car_status,
  get_area_one_car_info,
  g_one_car_real_info,
  get_one_car_history_info
} from "../../api/car_manage/car_manage";
let lishiguiji = [] //历史轨迹
let containerth = ""; //地图实例
let polyline3 = "" //历史轨迹线
let polyline4 = ""//实时轨迹线
let guijis = [] //实时轨迹
let markers = ''
let markers2 = ''
let timeout = ''
let xhtime = ''
let histime = ''
let zuzhitime = ''
let ladtime = ''
import { useStore } from "vuex";
import { RefreshRight } from "@element-plus/icons";
import { useRoute } from "vue-router";
import { reactive, onMounted, toRefs, onBeforeUnmount, ref, watch } from "vue";

export default {
  components: { ctar1, RefreshRight },
  name: "Bicycle_manage",
  setup() {
    const data = reactive({
      online_status: '',
      gps_status: '',
      input: "",
      value: "",
      value1: "",
      value2: '1',
      plays: true,
      showtab: true,
      loading: false,
      backid: 0,
      jiange: [
        {
          value: 1,
          label: 1,
        },
        {
          value: 2,
          label: 2,
        },
        {
          value: 3,
          label: 3,
        },
        {
          value: 5,
          label: 5,
        },
        {
          value: 10,
          label: 10,
        }, {
          value: 20,
          label: 20,
        },
        {
          value: 30,
          label: 30,
        },
        {
          value: 50,
          label: 50,
        },
      ],
      options: [
        {
          value: "15",
          label: "15条/页",
        },
        {
          value: "10",
          label: "10条/页",
        },
        {
          value: "5",
          label: "5条/页",
        },
      ],
      backcolor: ["child0", "child1", "child2", "child3", "child4"],
      sjvalue: '',
      car_list: "",
      table_page: {
        sum: 20,
        page: 1,
        limit: 10,
      },
      multipleSelection: [],
      listdata: "",
      area_name: "",
      area_id: "1",
      tableData: '',
      tree_data: [],
      vin: '',
      cishu: true,
      groupE: '',
      groupC: '',
      groupD: '',
      groupB: '',
      groupA: '',
      start_time: '',
      onetime: '',
      tian: '',
      launch: []

    });

    const filterText = ref('')
    const treeRef = ref('')

    const defaultProps = {
      children: 'children',
      label: 'label',
    }
    watch(filterText, (val) => {
      treeRef.value.filter(val)
    })
    const filterNode = (value, data) => {
      if (!value) return true
      return data.label.includes(value)
    }
    const Store = useStore();
    const route = useRoute();
    //秒 转换成时间
    const formatTooltip = (value) => {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime >= 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime >= 60) {
          hourTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var result = "" + (parseInt(secondTime) < 10 ? "0" + parseInt(secondTime) : parseInt(secondTime));

      // if (minuteTime > 0) {
      result = "" + (parseInt(minuteTime) < 10 ? "0" + parseInt(minuteTime) : parseInt(minuteTime)) + ":" + result;
      // }
      // if (hourTime > 0) {
      result = "" + (parseInt(hourTime) < 10 ? "0" + parseInt(hourTime) : parseInt(hourTime)) + ":" + result;
      // }
      return result;
    }

    //区域车辆列表
    const g_area_car_list = () => {
      localStorage.setItem("selectTab_item", "Bicycle_manage");
      Store.commit('gorouter', "Car_manage")
      data.backid = 0
      get_area_car_list(
        data.table_page.page,
        data.table_page.limit,
        data.area_id
      ).then((res) => {
        data.car_list = res.data;
        data.table_page.sum = res.count
        if (route.query.vin === undefined) {
          if (data.car_list.length != 0) {
            data.vin = data.car_list[0].vin
          }
        } else {
          data.vin = route.query.vin
        }
        time()

      });
    };
    //关注
    const f_car = (row) => {
      let vin = row.vin;

      let focus = row.is_focus == 0 ? 1 : 0;
      focus_car(vin, focus).then((res) => {
        g_area_car_list();
        g_all_car_status();
      });
    };

    //切换单车
    const togg = (vin, index) => {
      data.backid = index
      data.loading = true
      if (xhtime) {
        clearInterval(xhtime)
      }
      if (histime) {
        clearInterval(histime)
      }
      data.vin = vin
      timeout = setTimeout(() => {
        time()
      }, 500)
      ladtime = setTimeout(() => {
        data.loading = false
      }, 2300)

    }
    // 区域列表
    const g_area_list = () => {
      data.loading = true
      ladtime = setTimeout(() => {
        data.loading = false
      }, 6000)
      get_area_list(data.area_name).then((res) => {
        data.tree_data = [];
        data.tree_data.push(res.data);
        if (res.data.children.length != 0) {
          data.area_id = res.data.children[0].value
        }
        g_area_car_list();
      });
    };
    //判断 在不在线 渲染table
    const time = () => {
      containerth.clearMap();
      guijis = []
      if (timeout) {
        clearTimeout(timeout)
      }
      if (histime) {
        clearInterval(histime)
        data.value1 = ''
        data.sjvalue = ''
        data.plays = true
        data.value2 = 1
      }
      if (xhtime) {
        clearInterval(xhtime)
      }
      //清空实时轨迹
      guijis = []
      //清空历史轨迹
      lishiguiji = []
      data.cishu = true
      containerth.clearMap();
      xhtime = setInterval(() => {
        g_one_car_real_info(data.vin).then((res) => {
          if (res.code == 0) {
            data.tableData = res.data
            let lnglats = [res.data.longitude, res.data.latitude]
            let gps_type = res.data.gps_type
            data.online_status = res.data.online_status
            data.gps_status = res.data.gps_status
            AMap.convertFrom(lnglats, gps_type, function (status, result) {
              if (result.info === "ok") {
                var geocoder = new AMap.Geocoder({
                  city: "010", //城市设为北京，默认：“全国”
                  radius: 1000 //范围，默认：500
                });
                var resLnglat = result.locations[0];
                geocoder.getAddress(resLnglat, function (status, result) {
                  if (status === 'complete' && result.regeocode) {
                    var address = result.regeocode.formattedAddress;
                    data.tableData.groupA[4].value = address
                    data.groupE = data.tableData.groupE
                    data.groupC = data.tableData.groupC
                    data.groupD = data.tableData.groupD
                    data.groupB = data.tableData.groupB
                    data.groupA = data.tableData.groupA
                  } else {
                    data.tableData.groupA[4].value = ''
                    data.groupE = data.tableData.groupE
                    data.groupC = data.tableData.groupC
                    data.groupD = data.tableData.groupD
                    data.groupB = data.tableData.groupB
                    data.groupA = data.tableData.groupA
                  }
                });
              }
            });
            g_area_one_car_info()
          } else {
            data.groupE = []
            data.groupC = []
            data.groupD = []
            data.groupB = []
            data.groupA = []
            if (xhtime) {
              clearInterval(xhtime)
            }
          }

        })
      }, 1000)
    }

    //单车渲染
    const g_area_one_car_info = () => {
      get_area_one_car_info(data.vin).then((res) => {
        if (res.data.length != 0) {
          if (res.data[0].car_gps.length != 0 && res.data[0].car_gps[0].longitude != 0 && res.data[0].car_gps[0].latitude != 0) {
            let lnglat = [
              res.data[0].car_gps[0].longitude,
              res.data[0].car_gps[0].latitude];
            let icon = res.data[0].car_status_img;
            let type = res.data[0].gps_type;
            let course = res.data[0].car_gps[0].course;
            AMap.convertFrom(lnglat, type, function (status, result) {
              var startIcon = new AMap.Icon({
                image: icon,
                imageSize: new AMap.Size(25, 30),
              });
              if (result.info === "ok") {
                // var geocoder = new AMap.Geocoder({
                //   city: "010", //城市设为北京，默认：“全国”
                //   radius: 1000 //范围，默认：500
                // });
                // var resLnglat = result.locations[0];
                // geocoder.getAddress(resLnglat, function (status, result) {
                //   if (status === 'complete' && result.regeocode) {
                //     var address = result.regeocode.formattedAddress;
                //     data.tableData.groupA[4].value = address
                //     data.groupE = data.tableData.groupE
                //     data.groupC = data.tableData.groupC
                //     data.groupD = data.tableData.groupD
                //     data.groupB = data.tableData.groupB
                //     data.groupA = data.tableData.groupA
                //   }
                // });
                if (data.cishu) {
                  containerth.setZoomAndCenter(20, [
                    result.locations[0].lng,
                    result.locations[0].lat,
                  ]);
                  data.cishu = !data.cishu
                }
                if (markers) {
                  markers.setAngle(course);
                  markers.setIcon(startIcon);
                  markers.setPosition([
                    result.locations[0].lng,
                    result.locations[0].lat,
                  ]);
                } else {
                  markers = new AMap.Marker({
                    icon: startIcon,
                    position: [result.locations[0].lng, result.locations[0].lat],
                    offset: new AMap.Pixel(-13, -30),
                    angle: course,
                  });
                }
                markers.setMap(containerth);
                let pahts = [
                  result.locations[0].lng,
                  result.locations[0].lat,
                ]
                guijis.push(pahts);
                let dpaths = guijis.map((d) => {
                  return new AMap.LngLat(d[0], d[1]);
                });
                //判断 点的数量  进行 逻辑处理
                if (polyline4) {
                  //判断清空上一次的轨迹
                  containerth.remove(polyline4);
                }
                polyline4 = new AMap.Polyline({
                  path: dpaths,
                  borderWeight: 2, // 线条宽度，默认为 1
                  strokeColor: "#3366FF", // 线条颜色
                  lineJoin: "round", // 折线拐点连接处样式
                });
                containerth.add(polyline4);

              }
            });
          }

        }
      })

    }
    // 拖动时间条
    const updatetime = () => {
      if (!data.plays) {
        if (histime) {
          clearInterval(histime)
        }
        containerth.clearMap();
        lishiguiji = []
        playa(0)
      }

    }
    //播放
    const playa = (val) => {
      if (timeout) {
        clearTimeout(timeout)
      }

      if (xhtime) {
        clearInterval(xhtime)
      }

      if (val == 0) {
        data.plays = false
        let vin = data.vin
        let is_first = ''
        let tian = data.value1
        let start_time = data.value1 + ' ' + formatTooltip(data.sjvalue)
        if (start_time == data.start_time) {
          is_first = 0
        } else {
          is_first = 1
        }

        data.start_time = data.value1 + ' ' + formatTooltip(data.sjvalue)
        let interval = data.value2
        histime = setInterval(() => {
          get_one_car_history_info(vin, start_time, is_first, interval).then((res) => {
            if (res.code != -1) {
              if (res.data) {
                data.online_status = res.data.online_status
                data.gps_status = res.data.gps_status
                if (tian != data.tian) {
                  lishiguiji = []
                  containerth.clearMap();
                }
                data.tian = data.value1
                let shijian = captureTime(res.data.time)
                data.sjvalue = shijian
                if (!data.cishu) {
                  containerth.clearMap();
                  data.cishu = !data.cishu
                }
                is_first = 0
                data.tableData = res.data
                let cen = [res.data.longitude, res.data.latitude]
                let course = res.data.course
                let type = res.data.gps_type
                AMap.convertFrom(cen, type, function (status, result) {
                  var startIcon = new AMap.Icon({
                    image: res.data.image,
                    imageSize: new AMap.Size(25, 30),
                  });
                  if (result.info === "ok") {
                    if (markers2) {
                      markers2.setAngle(course);
                      markers.setIcon(startIcon);
                      markers2.setPosition([
                        result.locations[0].lng,
                        result.locations[0].lat,
                      ]);
                    } else {
                      markers2 = new AMap.Marker({
                        icon: startIcon,
                        position: [result.locations[0].lng, result.locations[0].lat],
                        offset: new AMap.Pixel(-13, -30),
                        angle: course,
                      });
                    }
                    var geocoder = new AMap.Geocoder({
                      city: "010", //城市设为北京，默认：“全国”
                      radius: 1000 //范围，默认：500
                    });
                    var resLnglat = result.locations[0];
                    geocoder.getAddress(resLnglat, function (status, result) {
                      if (status === 'complete' && result.regeocode) {
                        var address = result.regeocode.formattedAddress;
                        data.tableData.groupA[4].value = address
                        data.groupE = data.tableData.groupE
                        data.groupC = data.tableData.groupC
                        data.groupD = data.tableData.groupD
                        data.groupB = data.tableData.groupB
                        data.groupA = data.tableData.groupA
                      }
                    });
                    containerth.setCenter([result.locations[0].lng, result.locations[0].lat]); //设置地图中心点
                    markers2.setMap(containerth);
                    let pahts = [
                      result.locations[0].lng,
                      result.locations[0].lat,
                    ]

                    lishiguiji.push(pahts);
                    let shuzu = lishiguiji.map((d) => {
                      return new AMap.LngLat(d[0], d[1]);
                    });
                    if (polyline3) {
                      //判断清空上一次的轨迹
                      containerth.remove(polyline3);
                    }
                    polyline3 = new AMap.Polyline({
                      path: shuzu,
                      showDir: true,
                      strokeColor: "#28F",  //线颜色
                      // strokeOpacity: 1,     //线透明度
                      strokeWeight: 6,      //线宽
                      // strokeStyle: "solid"  //线样式
                    });

                    // let xian = new AMap.Polyline({
                    //   path: shuzu,
                    //   borderWeight: 2, // 线条宽度，默认为 1
                    //   strokeColor: "#3366FF", // 线条颜色
                    //   lineJoin: "round", // 折线拐点连接处样式
                    // });
                    containerth.add(polyline3);

                  }
                });
              } else {
                data.plays = true
                ElMessage({
                  message: '当前车辆没有数据',
                  type: 'warning',
                })
                clearInterval(histime)
              }

            } else {
              data.plays = true
              clearInterval(histime)
            }

          })

        }, 1000)
      } else {
        data.plays = !data.plays
        if (histime) {
          clearInterval(histime)
        }

      }
    }


    //车辆状态
    const g_all_car_status = () => {
      get_all_car_status().then((res) => {
        data.listdata = res.data;
      });
    };


    const captureTime = (fullTime) => {
      var timeArr = fullTime.replace(" ", ":").replace(/\:/g, "-").split("-");
      var nian = timeArr[0];
      var yue = timeArr[1];
      var ri = timeArr[2];
      var shi = timeArr[3];
      var fen = timeArr[4];
      var miao = timeArr[5];
      var shijian = Number(shi * 3600) + Number(fen * 60) + Number(miao);
      return shijian;
    }
    //查找车辆
    const lookup = () => {
      togg(data.input)
    }
    g_area_list();
    g_all_car_status();
    onMounted(() => {
      //加载地图
      containerth = new AMap.Map("container2", {
        resizeEnable: true, //是否监控地图容器尺寸变化
        mapStyle: "amap://styles/normal",
        center: [116.43, 28.92],
        zoom: "4",
      });

    });

    const handsize = (val) => {
      data.table_page.page = val;
      g_area_car_list();
    };

    //点击获取区域车辆
    const handleBucketClick = (e) => {
      if (data.launch.indexOf(e.value) > -1) {
        // 大于 0 代表存在，
        data.launch.splice(data.launch.indexOf(e.value), 1) // 存在就删除
      } else {
        data.launch.push(e.value)
      }
      if (e.value != undefined) {
        data.area_id = e.value
        g_area_car_list()
      }
    }
    zuzhitime = setInterval(() => {
      get_area_list(data.area_name).then((res) => {
        data.tree_data = [];
        data.tree_data.push(res.data);
      });
    }, 5000)
    onBeforeUnmount(() => {
      //销毁地图

      if (histime) {
        clearInterval(histime)
      }
      if (zuzhitime) {
        clearInterval(zuzhitime)
      }
      if (xhtime) {
        clearInterval(xhtime)
      }
      if (timeout) {
        clearInterval(timeout)
      }
      containerth.destroy();
    });
    return {
      ...toRefs(data),
      playa,
      f_car,
      handsize,
      g_area_list,
      g_area_one_car_info,
      togg,
      handleBucketClick,
      time,
      lookup,
      g_area_car_list,
      defaultProps,
      filterNode,
      filterText,
      treeRef,
      formatTooltip,
      updatetime
    };
  },
};
</script>
<style lang="scss" scoped>
.all {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/img/back.png");
  background-size: 100% 100%;
  position: relative;
}

.top_set {
  background-image: url("../../assets/img/top_set.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.bommot {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100;

  display: flex;
}

.el-menu {
  border: rgb(255, 255, 255);
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.rtar {
  height: 50%;
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top_screen {
  background-image: url("../../assets/img/top_screen.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_choose {
  background-image: url("../../assets/img/top_choose.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_dit {
  background-image: url("../../assets/img/top_dit.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_weix {
  background-image: url("../../assets/img/top_weix.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_cej {
  background-image: url("../../assets/img/top_cej.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_luk {
  background-image: url("../../assets/img/top_luk.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_kongq {
  background-image: url("../../assets/img/top_kongq.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_zuida {
  background-image: url("../../assets/img/top_zuida.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_xiaox {
  background-image: url("../../assets/img/top_xiaox.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

#container2 {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

/deep/.amap-copyright {
  font-size: 0px;
}

/deep/.amap-logo img {
  height: 0px !important;
  width: 0px !important;
}

.el-row {
  color: #000;
  text-align: center;
  margin-top: 5px;
}

.bommot1 {
  background-color: #0063ae;
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.right {
  width: 15%;
  height: 90%;
  position: absolute;
  background-color: rgb(255, 255, 255);
  right: 1%;
  top: 10%;
  z-index: 999;

  .right1 {
    height: 20%;
    background-color: rgb(255, 255, 255);
  }

  .right2 {
    height: 80%;
    font-size: 12px;
  }
}

.input {
  outline-style: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  width: 40px;
  height: 30px;
  font-size: 14px;
}

.sel {
  border-radius: 3px;
  height: 30px;
  font-size: 12px;
  width: 180px;
  color: #000;
  background-color: rgb(255, 255, 255);
}

.bommot2 {
  height: 8%;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  bottom: 0%;
  z-index: 99;
  font-size: 13px;

  .child0 {
    height: 90%;
    width: 17%;
    background-color: #bae7ff;
    border-radius: 5px;
  }

  .child2 {
    height: 90%;
    width: 17%;
    border-radius: 5px;
    background-color: #d9f7be;
  }

  .child3 {
    height: 90%;
    width: 17%;
    border-radius: 5px;
    background-color: #eeeeee;
  }

  .child4 {
    height: 90%;
    width: 17%;
    border-radius: 5px;
    background-color: #ffcdcd;
  }

  .child1 {
    height: 90%;
    width: 17%;
    border-radius: 5px;
    background-color: #ffe7ba;
  }
}

.center {
  display: flex;
  height: 50%;
  align-items: center;
  justify-content: center;
  color: #000;
}

.table5 {
  height: 100%;
  width: 20%;
}

.clickback {
  background-color: #3d464d2a;
}

.topselect {
  ::v-deep {
    .el-input__inner {
      height: 30px;
      border: 1px solid #01DEEF !important;
    }

    .el-input__prefix,
    .el-input__suffix {
      height: 20px;
    }

    /* 下面设置右侧按钮居中 */
    .el-input__suffix {
      top: 5px;
    }

    .el-input__icon {
      line-height: inherit;
    }

    .el-input__suffix-inner {
      display: inline-block;
    }
  }
}
</style>